var __jsx = React.createElement;
import React, { useState } from "react";
import { Icon } from "@syarahtech/ui";
import { SELL_TRADE_STATUS } from "@/pages/sell-trade-v2/sell-trade/constants";
import { useLang } from "@/common/Contexts/LanguageContext";
import { trackEvents } from "@/common/events/events";
import InfoCard from "./InfoCard";
import SimpleInfoCard from "./SimpleInfoCard";
import ActionButton from "./ActionButton";
import { useTranslation } from "@i18n";
import RescheduleAppointment from "@/components/CarSaleInfoBox/RescheduleAppointment";
import useBoolean from "@hooks/useBoolean";
import { Then } from "@componentsShared/Conditional/Then";
import { Drawer } from "vaul";
import { DrawerPortal } from "@/components/Drawer";
import { Else } from "@componentsShared/Conditional/Else";
import { Dialog, DialogContent } from "@/components/Dialog";
import { Conditional } from "@componentsShared/Conditional/Conditional";
import useIsMobile from "@hooks/useIsMobile";
var CarSaleInfoBox = function CarSaleInfoBox(_ref) {
  var _sellTradeItem$data;
  var sellTradeItem = _ref.sellTradeItem,
    onContactSupport = _ref.onContactSupport,
    onBookAppointment = _ref.onBookAppointment;
  var lang = useLang();
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  var reschedule = useBoolean();
  var isMobile = useIsMobile();
  var _useState = useState(sellTradeItem === null || sellTradeItem === void 0 ? void 0 : (_sellTradeItem$data = sellTradeItem.data) === null || _sellTradeItem$data === void 0 ? void 0 : _sellTradeItem$data.appointment_date),
    appointmentDate = _useState[0],
    setAppointmentDate = _useState[1];

  // Add null check
  if (!sellTradeItem || !sellTradeItem.current_status) {
    return null;
  }
  var statusId = sellTradeItem.current_status.id;

  // Helper function to get tracking data
  var getTrackingData = function getTrackingData() {
    var _sellTradeItem$make, _sellTradeItem$make2, _sellTradeItem$model, _sellTradeItem$model2, _sellTradeItem$data2;
    return {
      order_id: sellTradeItem.request_id || sellTradeItem.id,
      car_make: lang === "ar" ? (_sellTradeItem$make = sellTradeItem.make) === null || _sellTradeItem$make === void 0 ? void 0 : _sellTradeItem$make.name_ar : (_sellTradeItem$make2 = sellTradeItem.make) === null || _sellTradeItem$make2 === void 0 ? void 0 : _sellTradeItem$make2.name_en,
      car_model: lang === "ar" ? (_sellTradeItem$model = sellTradeItem.model) === null || _sellTradeItem$model === void 0 ? void 0 : _sellTradeItem$model.name_ar : (_sellTradeItem$model2 = sellTradeItem.model) === null || _sellTradeItem$model2 === void 0 ? void 0 : _sellTradeItem$model2.name_en,
      car_year: sellTradeItem.year,
      car_mileage_range: sellTradeItem.mileage_range || undefined,
      car_city: ((_sellTradeItem$data2 = sellTradeItem.data) === null || _sellTradeItem$data2 === void 0 ? void 0 : _sellTradeItem$data2.location) || undefined
    };
  };

  // Handle book appointment click with tracking
  var handleBookAppointment = function handleBookAppointment() {
    var trackingData = getTrackingData();
    trackEvents("tracking_book_appointment_click", trackingData);
    onBookAppointment === null || onBookAppointment === void 0 ? void 0 : onBookAppointment(sellTradeItem.request_id);
  };
  var renderInfoBox = function renderInfoBox() {
    var _sellTradeItem$curren, _sellTradeItem$curren2;
    var statusData = ((_sellTradeItem$curren = sellTradeItem.current_status) === null || _sellTradeItem$curren === void 0 ? void 0 : _sellTradeItem$curren.data) || [];
    var buttonText = (_sellTradeItem$curren2 = sellTradeItem.current_status) === null || _sellTradeItem$curren2 === void 0 ? void 0 : _sellTradeItem$curren2.button_text;
    switch (statusId) {
      case SELL_TRADE_STATUS.UNDER_INSPECTION:
        {
          var _sellTradeItem$data3;
          var appointmentData = statusData[0];
          var locationData = statusData[1];
          return /*#__PURE__*/React.createElement(React.Fragment, null, appointmentData && /*#__PURE__*/React.createElement("div", {
            id: "car-sale-info-appointment-".concat(sellTradeItem.request_id || sellTradeItem.id),
            className: "mb-4"
          }, /*#__PURE__*/React.createElement(InfoCard, {
            icon: appointmentData.logo,
            title: appointmentData.title,
            subtitle: appointmentData.appointment_date || appointmentDate,
            description: appointmentData.description,
            actionIcon: sellTradeItem !== null && sellTradeItem !== void 0 && sellTradeItem.edit_button && appointmentData.action ? /*#__PURE__*/React.createElement(Icon, {
              icon: "material-symbols--edit-outline",
              className: "text-primary-new",
              width: 8,
              height: 8
            }) : undefined,
            onActionClick: sellTradeItem !== null && sellTradeItem !== void 0 && sellTradeItem.edit_button && appointmentData.action ? function () {
              var trackingData = getTrackingData();
              trackEvents("edit_appointment", {
                order_id: trackingData.order_id
              });
              reschedule.setTrue();
            } : undefined
          })), locationData && /*#__PURE__*/React.createElement(InfoCard, {
            icon: locationData.logo,
            title: locationData.title,
            subtitle: locationData.location || (sellTradeItem === null || sellTradeItem === void 0 ? void 0 : (_sellTradeItem$data3 = sellTradeItem.data) === null || _sellTradeItem$data3 === void 0 ? void 0 : _sellTradeItem$data3.location),
            description: locationData.description,
            actionIcon: /*#__PURE__*/React.createElement(Icon, {
              icon: "material-symbols--location-on-outline",
              className: "text-primary-new",
              width: 8,
              height: 8
            }),
            onActionClick: function onActionClick() {}
          }));
        }
      case SELL_TRADE_STATUS.PURCHASED:
        {
          var purchasedData = statusData[0];
          return /*#__PURE__*/React.createElement("div", {
            id: "car-sale-info-purchased-".concat(sellTradeItem.request_id || sellTradeItem.id),
            className: "pb-16 md:pb-0"
          }, /*#__PURE__*/React.createElement(SimpleInfoCard, {
            icon: purchasedData === null || purchasedData === void 0 ? void 0 : purchasedData.logo,
            title: purchasedData === null || purchasedData === void 0 ? void 0 : purchasedData.title,
            description: purchasedData === null || purchasedData === void 0 ? void 0 : purchasedData.description,
            minHeight: "min-h-16"
          }), /*#__PURE__*/React.createElement(ActionButton, {
            onClick: onContactSupport,
            variant: "outline"
          }, buttonText));
        }
      case SELL_TRADE_STATUS.PENDING_BOOKING:
        {
          var pendingData = statusData[0];
          return /*#__PURE__*/React.createElement("div", {
            id: "car-sale-info-pending-booking-".concat(sellTradeItem.request_id || sellTradeItem.id),
            className: "pb-16 md:pb-0"
          }, /*#__PURE__*/React.createElement(SimpleInfoCard, {
            icon: pendingData === null || pendingData === void 0 ? void 0 : pendingData.logo,
            title: pendingData === null || pendingData === void 0 ? void 0 : pendingData.title,
            description: pendingData === null || pendingData === void 0 ? void 0 : pendingData.description
          }), /*#__PURE__*/React.createElement(ActionButton, {
            onClick: handleBookAppointment,
            variant: "primary"
          }, buttonText));
        }
      case SELL_TRADE_STATUS.AWAITING_OFFER_APPROVAL:
        {
          var offerData = statusData[0];
          return /*#__PURE__*/React.createElement("div", {
            id: "car-sale-info-awaiting-offer-".concat(sellTradeItem.request_id || sellTradeItem.id),
            className: "pb-16 md:pb-0"
          }, /*#__PURE__*/React.createElement(SimpleInfoCard, {
            icon: offerData === null || offerData === void 0 ? void 0 : offerData.logo,
            title: offerData === null || offerData === void 0 ? void 0 : offerData.title,
            description: offerData === null || offerData === void 0 ? void 0 : offerData.description
          }), /*#__PURE__*/React.createElement(ActionButton, {
            onClick: onContactSupport,
            variant: "outline"
          }, buttonText));
        }
      case SELL_TRADE_STATUS.UNDER_NEGOTIATION:
        {
          var negotiationData = statusData[0];
          return /*#__PURE__*/React.createElement("div", {
            id: "car-sale-info-negotiation-".concat(sellTradeItem.request_id || sellTradeItem.id),
            className: "pb-16 md:pb-0"
          }, /*#__PURE__*/React.createElement(SimpleInfoCard, {
            icon: negotiationData === null || negotiationData === void 0 ? void 0 : negotiationData.logo,
            title: negotiationData === null || negotiationData === void 0 ? void 0 : negotiationData.title,
            description: negotiationData === null || negotiationData === void 0 ? void 0 : negotiationData.description
          }), /*#__PURE__*/React.createElement(ActionButton, {
            onClick: onContactSupport,
            variant: "outline"
          }, buttonText));
        }
      default:
        return null;
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, renderInfoBox(), /*#__PURE__*/React.createElement(Conditional, {
    condition: isMobile
  }, /*#__PURE__*/React.createElement(Then, null, /*#__PURE__*/React.createElement(Drawer.Root, {
    open: reschedule.value,
    onOpenChange: reschedule.setTrue,
    onClose: reschedule.setFalse,
    snapPoints: [1],
    closeThreshold: 0.65
  }, /*#__PURE__*/React.createElement(DrawerPortal, null, /*#__PURE__*/React.createElement(Drawer.Overlay, {
    className: "fixed inset-0 bg-black/40 z-[9998]"
  }), /*#__PURE__*/React.createElement(Drawer.Content, {
    className: "bg-white flex flex-col rounded-t-[10px] h-full after:!h-fit mt-24 fixed bottom-0 left-0 right-0  overflow-y-auto z-[9999999999]"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-between p-4 sticky top-0 bg-white md:rounded-lg shadow-[0px_3px_2.299999952316284px_0px_rgba(0,0,0,0.03)]"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "font-bold text-base leading-4 text-primary-new"
  }, tShort("sell_trade_v2/booking_time", {
    ns: "web_sell_trade"
  })), /*#__PURE__*/React.createElement("div", {
    onClick: reschedule.setFalse
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--close-small-outline-rounded",
    width: 6,
    height: 6,
    className: "text-primary-new cursor-pointer"
  }))), /*#__PURE__*/React.createElement(RescheduleAppointment, {
    requestId: sellTradeItem.request_id,
    onSuccess: function onSuccess(newDate) {
      setAppointmentDate(newDate);
      reschedule.setFalse();
    }
  }))))), /*#__PURE__*/React.createElement(Else, null, /*#__PURE__*/React.createElement(Dialog, {
    open: reschedule.value,
    onOpenChange: reschedule.toggle
  }, /*#__PURE__*/React.createElement(DialogContent, {
    className: "w-[60%] max-h-[80vh] flex flex-col p-0 gap-0 overflow-y-auto",
    haveClose: false
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-between p-4 sticky top-0 bg-white md:rounded-lg shadow-[0px_3px_2.299999952316284px_0px_rgba(0,0,0,0.03)] z-[20]"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "font-bold text-base leading-4 text-primary-new"
  }, tShort("sell_trade_v2/booking_time", {
    ns: "web_sell_trade"
  })), /*#__PURE__*/React.createElement("div", {
    onClick: reschedule.setFalse
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--close-small-outline-rounded",
    width: 6,
    height: 6,
    className: "text-primary-new cursor-pointer"
  }))), /*#__PURE__*/React.createElement(RescheduleAppointment, {
    requestId: sellTradeItem.request_id,
    onSuccess: function onSuccess(newDate) {
      setAppointmentDate(newDate);
      reschedule.setFalse();
    }
  }))))));
};
export default CarSaleInfoBox;